import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
 import { SharedService } from '../shared/shared.service';
import { MsalService } from '@azure/msal-angular';
import { StorageService } from '../storage.service';
 
@Injectable()
export class KsaInterceptor implements HttpInterceptor {
  Groupcode: any;
  userEmail: any;
 
  constructor(private sharedService: SharedService,private authService: MsalService,private storageService: StorageService) { }
 
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let requestToForward = request;
    this.sharedService.groupCodeChangeObserve().subscribe((res) => {
      if (res)
        this.Groupcode = res;
    })
    this.userEmail =
    this.authService?.instance.getActiveAccount()?.username.toLowerCase().length > 0
      ? this.authService?.instance.getActiveAccount()?.username.toLowerCase()
      : this.storageService.deCodeJWT('preferred_username');
    let Country = this.storageService.getWithDefaultPassphrase("Country");
    if(Country=="KSA"){
     if(request.url.includes('phase2OutWardFileUpload.do')||request.url.includes('phase2EunitOutWardFileUpload.do')){
      if(this.userEmail)
      requestToForward = request.clone({ setHeaders: { 'Username':this.userEmail } });
      if(this.Groupcode)
      requestToForward = request.clone({ setHeaders: { 'Groupcode': this.Groupcode,'Username':this.userEmail } });
      
     }
    else{
      if(this.userEmail)
      requestToForward = request.clone({ setHeaders: { 'Username':this.userEmail ,'content-type': 'application/json'} });
      if(this.Groupcode)
      requestToForward = request.clone({ setHeaders: { 'Groupcode': this.Groupcode,'Username':this.userEmail ,'content-type': 'application/json' } });
    }
    }
 
 
    return next.handle(requestToForward);
  }
}